import * as React from "react";
import { forwardRef } from "react";
const SvgSelected = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, transform: "translate(8 8)" }, /* @__PURE__ */ React.createElement("path", { d: "M0 8 8 0" }), /* @__PURE__ */ React.createElement("path", { d: "M8 8 0 0" })));
const ForwardRef = forwardRef(SvgSelected);
export { ForwardRef as ReactComponent };
